import { AgentsFactoryActionTypes } from './agentsFactory.types';

const signupRequest = () => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_REQUEST });
const signupSuccess = agentAuth => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_SUCCESS, payload: agentAuth });
const signupFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_SIGNUP_FAILURE, payload: error });

const createRequest = (payload, onSuccess) => ({
  type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_REQUEST,
  payload,
  onSuccess,
});
const createSuccess = agentData => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_SUCCESS, payload: agentData });
const createFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CREATE_FAILURE, payload: error });

const changeStatusRequest = status => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_REQUEST, payload: status });
const changeStatusSuccess = agentData => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_SUCCESS, payload: agentData });
const changeStatusFailure = error => ({ type: AgentsFactoryActionTypes.AGENTS_FACTORY_CHANGE_STATUS_FAILURE, payload: error });

const actions = {
  signup: {
    request: signupRequest,
    success: signupSuccess,
    failure: signupFailure,
  },
  create: {
    request: createRequest,
    success: createSuccess,
    failure: createFailure,
  },
  changeStatus: {
    request: changeStatusRequest,
    success: changeStatusSuccess,
    failure: changeStatusFailure,
  },
};

export default actions;
